var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
var MiniCalendar = /** @class */ (function (_super) {
    __extends(MiniCalendar, _super);
    function MiniCalendar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.date = new Date();
        _this.weekDays = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"];
        return _this;
    }
    Object.defineProperty(MiniCalendar.prototype, "year", {
        get: function () {
            return this.date.getFullYear();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MiniCalendar.prototype, "month", {
        get: function () {
            return this.date.getMonth();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MiniCalendar.prototype, "monthName", {
        get: function () {
            return this.date.toLocaleString("pt-BR", { month: "long" }).toUpperCase();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MiniCalendar.prototype, "calendar", {
        get: function () {
            var firstDay = new Date(this.year, this.month, 1).getDay();
            var totalDays = new Date(this.year, this.month + 1, 0).getDate();
            var days = Array(firstDay).fill(null).concat(__spreadArrays(Array.from(Array(totalDays).keys())).map(function (d) { return d + 1; }));
            var weeks = [];
            while (days.length)
                weeks.push(days.splice(0, 7));
            return weeks;
        },
        enumerable: false,
        configurable: true
    });
    MiniCalendar.prototype.prevMonth = function () {
        this.date = new Date(this.year, this.month - 1, 1);
    };
    MiniCalendar.prototype.nextMonth = function () {
        this.date = new Date(this.year, this.month + 1, 1);
    };
    MiniCalendar.prototype.isToday = function (day) {
        var today = new Date();
        return day && this.year === today.getFullYear() && this.month === today.getMonth() && day === today.getDate();
    };
    MiniCalendar.prototype.isSelected = function (day) {
        var _this = this;
        return this.reservados.some(function (r) {
            var date = new Date(r);
            return _this.year === date.getFullYear() && _this.month === date.getMonth() && day === date.getDate();
        });
    };
    __decorate([
        Prop()
    ], MiniCalendar.prototype, "reservados", void 0);
    MiniCalendar = __decorate([
        Component({
            components: {}
        })
    ], MiniCalendar);
    return MiniCalendar;
}(Vue));
export default MiniCalendar;
